import { FONT_REGISTRY } from './font-registry';
import { buildGoogleFontsUrl } from './google-fonts-url';

const LINK_MARKER = 'data-app-fonts';

/**
 * Подключает Google-шрифты реестра одной ссылкой `<link rel="stylesheet">` в `<head>`.
 * Вызывается один раз на старте (`src/index.tsx`); повторный вызов ничего не добавляет.
 * `preconnect` к `fonts.googleapis.com` / `fonts.gstatic.com` уже стоит в `public/index.html`.
 */
export function loadAppFonts(doc: Document = document): void {
  if (doc.head.querySelector(`link[${LINK_MARKER}]`)) return;
  const link = doc.createElement('link');
  link.rel = 'stylesheet';
  link.href = buildGoogleFontsUrl(FONT_REGISTRY);
  link.setAttribute(LINK_MARKER, '');
  doc.head.appendChild(link);
}
